import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import {
  SiLinux,
  SiVisualstudiocode,
  SiPostman,
  SiHeroku,
  SiBitbucket,
  SiWindows,
  SiVercel,
  SiNetlify,
  SiAnsible,
} from "react-icons/si";
import { FaAws } from "react-icons/fa";
import { DiGit } from "react-icons/di";

function Toolstack() {
  const [showTextVscode, setshowTextVscode] = useState(false);
  const [showTextPostman, setshowTextPostman] = useState(false);
  const [showTextHeroku, setshowTextHeroku] = useState(false);
  const [showTextWindows, setshowTextWindows] = useState(false);
  const [showTextLinux, setshowTextLinux] = useState(false);
  const [showTextBitbucket, setshowTextBitbucket] = useState(false);
  const [showTextAws, setshowTextAws] = useState(false);
  const [showTextVercel, setshowTextVercel] = useState(false);
  const [showTextNetlify, setshowTextNetlify] = useState(false);
  const [showTextGit, setShowTextGit] = useState(false);
  const [showTextAnsible, setShowTextAnsible] = useState(false);

  const handleMouseEnterVscode = () => {
    setshowTextVscode(true);
  };
  const handleMouseLeaveVscode = () => {
    setshowTextVscode(false);
  };
  const handleMouseEnterPostman = () => {
    setshowTextPostman(true);
  };
  const handleMouseLeavePostman = () => {
    setshowTextPostman(false);
  };
  const handleMouseEnterHeroku = () => {
    setshowTextHeroku(true);
  };
  const handleMouseLeaveHeroku = () => {
    setshowTextHeroku(false);
  };
  const handleMouseEnterWindows = () => {
    setshowTextWindows(true);
  };
  const handleMouseLeaveWindows = () => {
    setshowTextWindows(false);
  };
  const handleMouseEnterLinux = () => {
    setshowTextLinux(true);
  };
  const handleMouseLeaveLinux = () => {
    setshowTextLinux(false);
  };
  const handleMouseEnterBitbucket = () => {
    setshowTextBitbucket(true);
  };
  const handleMouseLeaveBitbucket = () => {
    setshowTextBitbucket(false);
  };
  const handleMouseEnterAws = () => {
    setshowTextAws(true);
  };
  const handleMouseLeaveAws = () => {
    setshowTextAws(false);
  };
  const handleMouseEnterVercel = () => {
    setshowTextVercel(true);
  };
  const handleMouseLeaveVercel = () => {
    setshowTextVercel(false);
  };
  const handleMouseEnterNetlify = () => {
    setshowTextNetlify(true);
  };
  const handleMouseLeaveNetlify = () => {
    setshowTextNetlify(false);
  };
  const handleMouseEnterGit = () => {
    setShowTextGit(true);
  };

  const handleMouseLeaveGit = () => {
    setShowTextGit(false);
  };
  const handleMouseEnterAnsible = () => {
    setShowTextAnsible(true);
  };

  const handleMouseLeaveAnsible = () => {
    setShowTextAnsible(false);
  };
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col
        xs={4}
        md={2}
        className="tech-icons"
        onMouseEnter={handleMouseEnterVscode}
        onMouseLeave={handleMouseLeaveVscode}
      >
        <SiVisualstudiocode />
        {showTextVscode && <p className="tech-icons-text">VS Code</p>}
      </Col>
      <Col
        xs={4}
        md={2}
        className="tech-icons"
        onMouseEnter={handleMouseEnterAws}
        onMouseLeave={handleMouseLeaveAws}
      >
        <FaAws />
        {showTextAws && <p className="tech-icons-text">AWS</p>}
      </Col>
      <Col
        xs={4}
        md={2}
        className="tech-icons"
        onMouseEnter={handleMouseEnterPostman}
        onMouseLeave={handleMouseLeavePostman}
      >
        <SiPostman />
        {showTextPostman && <p className="tech-icons-text">Postman</p>}
      </Col>

      <Col
        xs={4}
        md={2}
        className="tech-icons"
        onMouseEnter={handleMouseEnterHeroku}
        onMouseLeave={handleMouseLeaveHeroku}
      >
        <SiHeroku />
        {showTextHeroku && <p className="tech-icons-text">Heroku</p>}
      </Col>
      <Col
        xs={4}
        md={2}
        className="tech-icons"
        onMouseEnter={handleMouseEnterWindows}
        onMouseLeave={handleMouseLeaveWindows}
      >
        <SiWindows />
        {showTextWindows && <p className="tech-icons-text">Windows</p>}
      </Col>
      <Col
        xs={4}
        md={2}
        className="tech-icons"
        onMouseEnter={handleMouseEnterLinux}
        onMouseLeave={handleMouseLeaveLinux}
      >
        <SiLinux />
        {showTextLinux && <p className="tech-icons-text">Linux</p>}
      </Col>
      <Col
        xs={4}
        md={2}
        className="tech-icons"
        onMouseEnter={handleMouseEnterAnsible}
        onMouseLeave={handleMouseLeaveAnsible}
      >
        <SiAnsible />
        {showTextAnsible && <p className="tech-icons-text">Ansible</p>}
      </Col>
      <Col
        xs={4}
        md={2}
        className="tech-icons"
        onMouseEnter={handleMouseEnterGit}
        onMouseLeave={handleMouseLeaveGit}
      >
        <DiGit />
        {showTextGit && <p className="tech-icons-text">Git Hub</p>}
      </Col>
      <Col
        xs={4}
        md={2}
        className="tech-icons"
        onMouseEnter={handleMouseEnterBitbucket}
        onMouseLeave={handleMouseLeaveBitbucket}
      >
        <SiBitbucket />
        {showTextBitbucket && <p className="tech-icons-text">BitBucket</p>}
      </Col>
      <Col
        xs={4}
        md={2}
        className="tech-icons"
        onMouseEnter={handleMouseEnterVercel}
        onMouseLeave={handleMouseLeaveVercel}
      >
        <SiVercel />
        {showTextVercel && <p className="tech-icons-text">Vercel</p>}
      </Col>
      <Col
        xs={4}
        md={2}
        className="tech-icons"
        onMouseEnter={handleMouseEnterNetlify}
        onMouseLeave={handleMouseLeaveNetlify}
      >
        <SiNetlify />
        {showTextNetlify && <p className="tech-icons-text">Netlify</p>}
      </Col>
    </Row>
  );
}

export default Toolstack;
